import styled from 'styled-components';

import { colors } from 'theme/colors';

export const EventItemLayout = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
`;

export const ItemDate = styled.p`
  color: ${colors.ui.chip.grayText};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
  margin: 0;
`;

export const EventText = styled.p`
  color: ${colors.ui.chip.grayText};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
  margin: 0;
  white-space: pre-line;
  word-break: break-word;
  span {
    font-weight: 700;
  }
`;
